import { post, put, get, remove } from 'communication/httpClient';
import {
  LOAD_BUSINESS_RULES,
  BUSINESS_RULES_LOADED,
  RESET_BUSINESS_RULES,
  RESET_BUSINESS_RULE,
  SYNC_FAILED,
  BUSINESS_RULE_DELETED,
  LOAD_BUSINESS_RULES_TYPES,
  BUSINESS_RULES_TYPES_LOADED,
  LOAD_BUSINESS_RULES_ACTION,
  BUSINESS_RULES_ACTION_LOADED,
  LOAD_BUSINESS_RULE,
  BUSINESS_RULE_LOADED,
  SAVE_BUSINESS_RULE,
  BUSINESS_RULES_SAVED,
  SET_RULE_ID,
  RESET_RULE_ID,
} from './actionTypes';

export const initialActionsState = {
  loadBusinessRules: () => {},
  resetBusinessRules: () => {},
  resetBusinessRule: () => {},
  deleteBusinessRule: () => {},
  loadBusinessTypes: () => {},
  addBusinessRule: () => {},
  loadActionType: () => {},
  loadBusinessRule: (id: string) => {},
  updateBusinessRulesSavedValue: () => {},
  setRuleId: (id?: string) => {},
  resetRuleId: () => {},
};

export const getActions = (dispatch: {
  (value: { type: any; payload?: any }): void;
  (arg0: { type: string; payload?: any }): void;
}) => ({
  loadBusinessRules: async () => {
    dispatch({
      type: LOAD_BUSINESS_RULES,
    });
    const { data, error } = await get('/api/business-rules');

    if (data) {
      dispatch({
        type: BUSINESS_RULES_LOADED,
        payload: data,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },
  loadBusinessRule: async (id: string) => {
    dispatch({
      type: LOAD_BUSINESS_RULE,
    });
    const { data, error } = await get('/api/business-rules/' + id);

    if (data) {
      dispatch({
        type: BUSINESS_RULE_LOADED,
        payload: data,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },
  loadBusinessTypes: async () => {
    dispatch({
      type: LOAD_BUSINESS_RULES_TYPES,
    });
    const { data, error } = await get('/api/business-rules/types');

    if (data) {
      dispatch({
        type: BUSINESS_RULES_TYPES_LOADED,
        payload: data,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },
  resetBusinessRules: () =>
    dispatch({
      type: RESET_BUSINESS_RULES,
    }),
  resetBusinessRule: () =>
    dispatch({
      type: RESET_BUSINESS_RULE,
    }),
  deleteBusinessRule: async (ruleId: string, callback?: () => void) => {
    const { data, error } = await remove('/api/business-rules/' + ruleId);
    if (data || data === '') {
      dispatch({
        type: BUSINESS_RULE_DELETED,
        payload: ruleId,
      });
      if (callback) {
        callback();
      }
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },
  addBusinessRule: async (values: any, id?: string, onSuccess?: (id?: string) => void) => {
    dispatch({
      type: SAVE_BUSINESS_RULE,
    });
    const handler = id ? put : post,
      resourceId = id || '';
    const { data, error, success } = await handler('/api/business-rules/' + resourceId, values);

    if (success && onSuccess) onSuccess(id || data);

    if (data) {
      dispatch({
        type: SET_RULE_ID,
        payload: data,
      });
      dispatch({
        type: BUSINESS_RULES_SAVED,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },
  setRuleId: (id?: string) => {
    dispatch({
      type: SET_RULE_ID,
      payload: id,
    });
  },
  resetRuleId: () => {
    dispatch({
      type: RESET_RULE_ID,
    });
  },
  updateBusinessRulesSavedValue: () => {
    dispatch({
      type: BUSINESS_RULES_SAVED,
    });
  },
  loadActionType: async () => {
    dispatch({
      type: LOAD_BUSINESS_RULES_ACTION,
    });
    const { data, error } = await get('/api/business-rules/actions');
    if (data || data === '') {
      dispatch({
        type: BUSINESS_RULES_ACTION_LOADED,
        payload: data,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },
});
